import Component from 'inferno-component';
import { Grid } from 'semantic-ui-react';
import './Footer.css';
import FooterLinks from './FooterLinks';

export default class Footer extends Component {
  render() {
    return (
        <Grid fluid className='footer'>
          <FooterLinks />
          <Grid.Row centered className='footer'>
            ©&nbsp;{new Date().getFullYear()} Minden&nbsp;jog&nbsp;fenntartva&nbsp;UnivAdvert&nbsp;Kft.
          </Grid.Row>
        </Grid>

    );
  }
}



// WEBPACK FOOTER //
// ./src/components/footer/Footer.js